// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__ueof1","title":"NotFound_title__Sph--","text":"NotFound_text__0lUpg","boldText":"NotFound_boldText__BUeJ-"};